import './css/index.scss'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


import http from './utils/ajax'
import Vant from 'vant'
import '@/plugins/index'
import 'vant/lib/index.css'
import i18n from './lang'
import './intercept'
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";


import { Toast } from 'vant'

Vue.prototype.$http = http
Vue.prototype.$toast = Toast
Vue.config.productionTip = false

Vue.use(Vant)
Vue.use(VueAwesomeSwiper /* { default options with global component } */);
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
